import React, { useState } from 'react';
import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Button,
  Typography,
  Box,
  IconButton,
  Snackbar
} from '@mui/material';
import { motion } from 'framer-motion';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { API_ENDPOINT } from '../config';

const NginxFileGenerator = () => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [domain, setDomain] = useState('');
  const [tryIndex, setTryIndex] = useState(false);
  const [isPhp, setIsPhp] = useState(false);
  const [proxy, setProxy] = useState('');
  const [result, setResult] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    event.preventDefault();

    const params = {
      domain: domain,
      try_index: tryIndex,
      is_php: isPhp,
      proxy
    };

    try {
      console.log(params)
      const response = await fetch(API_ENDPOINT + 'servertools/ngnix-config?domain=' + domain + '&try_index=' + tryIndex + '&is_php=' + isPhp + '&proxy=' + proxy);
      setResult(response.text());
    } catch (error) {
      setResult('An error occurred while generating the NGINX configuration.');
    }
  };

  const handleCopy = () => {
    navigator.clipboard.writeText(result).then(() => {
      setCopySuccess(true);
    });
  };

  return (
    <Container maxWidth="sm" sx={{ mt: 5 }}>
      <Helmet>
        <title>Nginx Configuration & Rule Builder | Redmorus</title>
        <meta name="description" content="Use RedMorus to visually build and deploy Nginx configurations. Easily set up rules for performance, security, geo-blocking, and bot control." />
      </Helmet>

      <Box display="flex" alignItems="center" sx={{ mb: 2 }}>
        <motion.div
          whileHover={{ x: -5 }}
          transition={{ type: 'spring', stiffness: 300 }}
        >
          <IconButton onClick={() => navigate('/')} color="primary">
            <ArrowBackIcon />
          </IconButton>
        </motion.div>
        <Typography variant="h6" sx={{ ml: 1 }}>
          Back
        </Typography>
      </Box>
      <Box display="flex" alignItems="center">
        <Box
          component="img"
          src="/logo64.png"
          alt="Redmorus Logo"
          sx={{ width: 20, height: 20, mr: 1 }}
        />
        <Typography variant="h6" fontWeight="bold" color="text.primary">
          Redmorus
        </Typography>
      </Box>
      <Typography variant="h4" component="h1" gutterBottom>
        NGINX File Generator
      </Typography>

      <form onSubmit={handleSubmit}>
        <TextField
          fullWidth
          label="Domain Name"
          value={domain}
          onChange={(e) => setDomain(e.target.value)}
          margin="normal"
          required
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={tryIndex}
              onChange={(e) => setTryIndex(e.target.checked)}
            />
          }
          label="Try Index"
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={isPhp}
              onChange={(e) => setIsPhp(e.target.checked)}
            />
          }
          label="Is PHP Active"
        />

        <TextField
          fullWidth
          label="Proxy (if available)"
          value={proxy}
          onChange={(e) => setProxy(e.target.value)}
          margin="normal"
        />

        <Button type="submit" variant="contained" color="primary">
          Generate
        </Button>
      </form>

      {result && (
        <Box mt={4}>
          <Typography variant="subtitle1">Generated Config:</Typography>
          <Button
            size="small"
            variant="outlined"
            onClick={handleCopy}
            startIcon={<ContentCopyIcon />}
          >
            Copy
          </Button>
          <pre style={{ whiteSpace: 'pre-wrap', wordWrap: 'break-word' }}>{result}</pre>
        </Box>
      )}
      <Snackbar
        open={copySuccess}
        autoHideDuration={3000}
        onClose={() => setCopySuccess(false)}
        message="Password copied to clipboard"
      />
    </Container>
  );
};

export default NginxFileGenerator;
